import React from 'react'
import type { SelectChangeEvent } from '@mui/material'
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_USER_LANGS, SUPPORTED_TARGET_LANGS } from '@/constants/languages'

interface LanguageSelectorsProps {
    userLang: string
    targetLang: string
    onUserLangChange: (e: SelectChangeEvent) => void
    onTargetLangChange: (e: SelectChangeEvent) => void
}

export const LanguageSelectors: React.FC<LanguageSelectorsProps> = ({
    userLang,
    targetLang,
    onUserLangChange,
    onTargetLangChange,
}) => {
    const { t } = useTranslation()

    return (
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <FormControl fullWidth variant="outlined">
                <InputLabel id="userLang-label" variant="outlined">
                    {t('profile:languages.nativeLanguage')}
                </InputLabel>
                <Select
                    variant="outlined"
                    name="userLang"
                    labelId="userLang-label"
                    label={t('profile:languages.nativeLanguage')}
                    value={userLang}
                    onChange={onUserLangChange}
                    disabled
                >
                    {SUPPORTED_USER_LANGS.map((lang) => (
                        <MenuItem key={lang.code} value={lang.code}>
                            {lang.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl fullWidth variant="outlined">
                <InputLabel id="targetLang-label" variant="outlined">
                    {t('profile:languages.targetLanguages')}
                </InputLabel>
                <Select
                    variant="outlined"
                    name="targetLang"
                    labelId="targetLang-label"
                    label={t('profile:languages.targetLanguages')}
                    value={targetLang}
                    onChange={onTargetLangChange}
                >
                    {SUPPORTED_TARGET_LANGS.map((lang) => (
                        <MenuItem key={lang.code} value={lang.code}>
                            {lang.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    )
}
